import _ from 'lodash';
import WixEvent from '../events/WixEvent';

/**
 * @callback $w.GoogleMapClickEvent
 * @summary Handles events fired when google map / marker is clicked.
 * @param {$w.GoogleMapClickEvent} event The mouse click event that occurred.
 */

/**
 * @callback $w.GoogleMapClickEvent
 * @summary Handles events fired when google map / marker is clicked.
 * @description
 *  A `GoogleMapClickEvent` event occurs when the user clicks a marker or a location in a map.
 * @memberof $w
 * @mixes $w.Event
 */
class GoogleMapClickEvent extends WixEvent {
    constructor(target, event, EventTypes, type) {
        super(target, event);

        this.location = _.get(event, 'location') || {longitude: _.get(event, 'longitude'), latitude: _.get(event, 'latitude')};
        if (type === EventTypes.GOOGLE_MAP_MARKER_CLICKED) {
            this.icon = _.get(event, 'icon');
            this.link = _.get(event, 'link');
            this.address = _.get(event, 'address');
            this.title = _.get(event, 'title');
            this.linkTitle = _.get(event, 'linkTitle');
            this.description = _.get(event, 'description');
        }
    }
}

export default GoogleMapClickEvent;
